import React, { useState } from 'react';
import _ from 'lodash';
import {
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import * as estimateSummaryService from 'services/estimateSummaries';

import { toast, canAccess as canAccessUtil } from 'utils/helpers';
import { FormField2 as Field, CommonDialog } from 'components';

const EstimateSummaryTransferModal = ({ summaryId, onClose, }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState('');

  const handleEmailChange = ({ value }) => {
    setRecipientEmail(value);
  }

  const handleSubmitTransfer = async () => {
    setLoading(true);

    if (!recipientEmail) {
      toast(t('Įveskite gavėjo el. paštą'), 'error');
      return;
    }

    try {
      await estimateSummaryService.transfer(summaryId, recipientEmail);
      toast(`${t('Perkėlimas sėkmingai nusiųstas')} ${recipientEmail}`);
    } catch (err) {
      console.error(err);
      window.alert(t('Įvyko klaida'));
    }

    setLoading(false);

    onClose();
  }

  return (
    <CommonDialog
      visible
      onClose={onClose}
      maxWidth="xs"
      style={{ position: 'relative' }}
      actions={[
        <Button
          color="default"
          variant="text"
          onClick={() => onClose()}
        >
          Atšaukti
        </Button>,
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmitTransfer}
        >
          Vykdyti
        </Button>
      ]}
    >
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>{t('Suvestinio skaičiavimo objekto perkėlimas kitam vartotojui')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Field
                  name="recipientEmail"
                  value={recipientEmail || ''}
                  label={t('El. paštas')}
                  required
                  onChange={handleEmailChange}
                  autoComplete="off"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </CommonDialog>
  )
}

export default EstimateSummaryTransferModal;